/**
 * @author Rahul Nainala
 * @description 
 */
import '../CSS/eLog.css';
import moment from 'moment';
import React, { useState } from 'react';
import { SelectComponent } from '../Widgets';
import { Input, Descriptions, InputNumber, TimePicker, message } from 'antd';

const Header = (props) => {
  const [, setValue] = useState('');
  const handleFieldChange = (value, columnKey) => {
    setValue({
      value,
      key: columnKey
    });
  };

  // const handleKeyPress = () => { };

  const checkOverlap = (timeSegments) => {
    timeSegments = timeSegments.filter(function (element) {
      return element !== undefined;
    });

    if (timeSegments.length === 1) return false;

    timeSegments.sort((timeSegment1, timeSegment2) =>
      timeSegment1[0].localeCompare(timeSegment2[0])
    );

    for (let i = 0; i < timeSegments.length - 1; i++) {
      const currentEndTime = timeSegments[i][1];
      const nextStartTime = timeSegments[i + 1][0];

      if (currentEndTime > nextStartTime) {
        return true;
      }
    }

    return false;
  };

  const onChange = (time, columnKey, key) => {
    let { headerValue, form, sectioName } = props;
    let timeSelectionArray = Object.keys(form).map((timeKey) => {
      if (
        form[timeKey] &&
        form[timeKey]['headerValue'] &&
        timeKey !== sectioName &&
        form[timeKey]['headerValue'][key]
      ) {
        return form[timeKey]['headerValue'][key].split('-');
      }
      return {};
    });

    let previousValue = headerValue && headerValue[key] && headerValue[key].split('-');
    if (
      columnKey === 'startTime' &&
      previousValue &&
      Array.isArray(previousValue) &&
      previousValue.length > 1
    ) {
      var startTime = moment(time);
      var endTime = moment(previousValue[1], 'h:mm');

      let newTimeRange = moment(time).format('HH:mm') + '-' + previousValue[1];
      let newObj = [moment(time).format('HH:mm'), previousValue[1]];
      timeSelectionArray.push(newObj);
      let result = checkOverlap(timeSelectionArray);
      if (result && result === true) {
        message.warn('TimeRanges overlapping with others');
      } else if (!startTime.isBefore(endTime)) {
        message.warn('Start Time is more than End Time');
      } else {
        setValue({
          value: newTimeRange,
          key
        });
      }
    } else if (
      columnKey === 'endTime' &&
      previousValue &&
      Array.isArray(previousValue) &&
      previousValue.length > 1
    ) {
      let newObj = [previousValue[0], moment(time).format('HH:mm')];
      timeSelectionArray.push(newObj);
      let result = checkOverlap(timeSelectionArray);
      let newTimeRange = previousValue[0] + '-' + moment(time).format('HH:mm');
      if (result && result === true) {
        message.warn('TimeRanges overlapping with others');
      } else if (!startTime.isBefore(endTime)) {
        message.warn(' Start Time is more than End Time');
      } else {
        setValue({
          value: newTimeRange,
          key
        });
      }
    } else {
      if (columnKey === 'startTime') {
        let newObj = [moment(time).format('HH:mm'), moment(time).add('hour', 1).format('HH:mm')];
        timeSelectionArray.push(newObj);
        let result = checkOverlap(timeSelectionArray);
        if (result && result === true) {
          message.warn('TimeRanges overlapping with others');
        } else {
          setValue({
            value: moment(time).format('HH:mm') + '-' + moment(time).add('hour', 1).format('HH:mm'),
            key
          });
        }
      } else if (columnKey === 'endTime') {
        let newObj = [moment(time).format('HH:mm'), moment(time).add('hour', 1).format('HH:mm')];
        timeSelectionArray.push(newObj);
        let result = checkOverlap(timeSelectionArray);
        if (result && result === true) {
          message.warn('TimeRanges overlapping with others');
        } else {
          setValue({
            value:
              moment().subtract('hour', 1).format('HH:mm') + '-' + moment(time).format('HH:mm'),
            key
          });
        }
      }
    }
  };

  let { header, headerValue, recordType, status } = props;
  return (
    <Descriptions bordered  column={2}>
      {headerValue &&
        headerValue !== undefined &&
        header &&
        header.map((eachHeader, index) => {
          if (eachHeader.key === 'userName') {
            return (
              <Descriptions.Item key={index} label={eachHeader.name}>
                {headerValue['userName']}
              </Descriptions.Item>
            );
          } else if (eachHeader.key === 'CurrentDate') {
            return (
              <Descriptions.Item key={index} label={eachHeader.name}>
                {headerValue['CurrentDate']}
              </Descriptions.Item>
            );
          } else if (eachHeader.key === 'CurrentTime') {
            return (
              <Descriptions.Item key={index} label={eachHeader.name}>
                {headerValue['CurrentTime']}
              </Descriptions.Item>
            );
          } else if (eachHeader.key === 'date' || eachHeader.key === 'location') {
            return (
              <Descriptions.Item key={index} label={eachHeader.name}>
                {headerValue[eachHeader.key]}
              </Descriptions.Item>
            );
          } else if (
            (eachHeader.key === 'SubmitDate' || eachHeader.key === 'SubmitTime') &&
            status !== 'Completed'
          ) {
            return null;
          } else {
            return (
              <Descriptions.Item key={index} label={eachHeader.name}>
                <div>
                  {eachHeader.widget === 'input' ? (
                    <Input
                      style={{ fontWeight: 'bold' }}
                      defaultValue={headerValue ? headerValue[eachHeader.key] : ''}
                      disabled={recordType === 'Approver' ? true : false}
                      placeholder={eachHeader.placeHolder}
                      onChange={(e) =>
                        setValue({
                          value: e.target.value,
                          key: eachHeader.key
                        })
                      }
                    />
                  ) : null}
                  {eachHeader.widget === 'inputNumber' ? (
                    <InputNumber
                      style={{ fontWeight: 'bold', width: 300 }}
                      min={eachHeader.min || 1}
                      max={eachHeader.max || 10000}
                      placeholder={eachHeader.placeHolder}
                      defaultValue={headerValue ? headerValue[eachHeader.key] : ''}
                      disabled={recordType === 'Approver' ? true : false}
                      onChange={(e) =>
                        setValue({
                          value: e,
                          key: eachHeader.key
                        })
                      }
                    />
                  ) : null}
                  {eachHeader.widget && eachHeader.widget === 'select' ? (
                    <SelectComponent
                      column={eachHeader}
                      record={{}}
                      text={headerValue ? headerValue[eachHeader.key] : ''}
                      handleFieldChange={handleFieldChange}
                      // handleKeyPress={handleKeyPress}
                    />
                  ) : null}

                  {eachHeader.widget && eachHeader.widget === 'timeRange' ? (
                    <div>
                      <TimePicker
                        placeholder="Start Time"
                        value={
                          headerValue && headerValue[eachHeader.key]
                            ? moment(headerValue[eachHeader.key].split('-')[0], 'HH:mm')
                            : ''
                        }
                        onChange={(e) => onChange(e, 'startTime', eachHeader.key)}
                      />
                      -
                      <TimePicker
                        placeholder="End Time"
                        value={
                          headerValue && headerValue[eachHeader.key]
                            ? moment(headerValue[eachHeader.key].split('-')[1], 'HH:mm')
                            : ''
                        }
                        onChange={(e) => onChange(e, 'endTime', eachHeader.key)}
                      />
                    </div>
                  ) : null}

                  {!eachHeader.widget || eachHeader.widget === 'text' ? (
                    eachHeader.name === 'Submitted Date' ? (
                      <div>
                        {headerValue && headerValue[eachHeader.key]
                          ? moment
                            .utc(headerValue[eachHeader.key])
                            .local()
                            .format('YYYY-MM-DD HH:mm:ss')
                          : null}
                      </div>
                    ) : null
                  ) : (
                    <div>{headerValue && headerValue[eachHeader.key]} </div>
                  )}
                </div>
              </Descriptions.Item>
            );
          }
        })}
    </Descriptions>
  );
};

export default Header;
